/**
 * Root reducer.
 * @module reducers/root
 */

import defaultReducers from '@plone/volto/reducers';
import getHeaderDates from './header';
import getExportedMenus from './export';
/**
 * Root reducer.
 * @function
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
const reducers = {
  ...defaultReducers,
  getHeaderDates,
  getExportedMenus,
  // Add your reducers here
};

export default reducers;
